import {LastViewedVideoScreen} from "@/components/media/LastViewedVideoScreen";
import {useLocalSearchParams} from "expo-router";

export default function LastViewedVideos() {
    const {orgId} = useLocalSearchParams<{ orgId: string }>();
    return (
        <LastViewedVideoScreen orgId={orgId} />
    );
}
